import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsAndConditions.css';

function TermsAndConditions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
        <div className="lp-topbar">
            <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
            <Link to="/login" className="lp-login-btn">Login</Link>
        </div>

        <div className="terms-and-conditions-container">            
            <h1>Terms and Conditions</h1>
            <div className="terms-content">
                <p class="tc-effective-date"><strong>Effective Date:</strong> 02/23/2026</p>

                <section class="tc-section">
                    <h2 class="tc-heading">1. Introduction</h2>
                    <p class="tc-text">
                    These Terms and Conditions (“Terms”) govern your access to and use of aistCRM (“Service”),
                    a cloud-based customer relationship management platform for language schools.
                    By creating an account or using the Service, you agree to these Terms.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">2. Eligibility</h2>
                    <p class="tc-text">
                    You must be at least 18 years old and have authority to bind your organization.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">3. Subscription and Billing</h2>
                    <ul class="tc-list">
                    <li>Subscriptions are billed in advance (monthly or annually).</li>
                    <li>Prices are displayed in USD.</li>
                    <li>Taxes, if applicable, are your responsibility.</li>
                    </ul>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">4. 14-Day Money-Back Guarantee</h2>
                    <p class="tc-text">
                    New customers are eligible for a full refund within fourteen (14) calendar days
                    from the date of the initial subscription purchase.
                    </p>
                    <ul class="tc-list">
                    <li>Applies only to the first subscription payment.</li>
                    <li>Does not apply to renewals.</li>
                    <li>Requests must be sent to support@aistcrm.com.</li>
                    </ul>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">5. Account Responsibility</h2>
                    <p class="tc-text">
                    You are responsible for maintaining the confidentiality of your account credentials
                    and all activities under your account.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">6. Customer Data</h2>
                    <p class="tc-text">
                    You retain ownership of all data uploaded to the Service.
                    aistCRM processes such data solely to provide the Service.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">7. Acceptable Use</h2>
                    <ul class="tc-list">
                    <li>No unlawful use.</li>
                    <li>No reverse engineering.</li>
                    <li>No interference with platform security.</li>
                    <li>No malicious code uploads.</li>
                    </ul>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">8. Intellectual Property</h2>
                    <p class="tc-text">
                    All intellectual property rights in the Service remain the exclusive property of aistCRM.
                    A limited, non-exclusive license is granted during the subscription term.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">9. Limitation of Liability</h2>
                    <p class="tc-text">
                    To the maximum extent permitted by law, aistCRM shall not be liable for indirect,
                    incidental, or consequential damages. Total liability shall not exceed the amount
                    paid during the three (3) months preceding the claim.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">10. Governing Law</h2>
                    <p class="tc-text">
                    These Terms shall be governed by the laws of the Republic of Chile.
                    Any disputes shall be subject to the exclusive jurisdiction of Chilean courts.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">11. Contact</h2>
                    <p class="tc-text">
                    Email: support@aistcrm.com<br/>
                    Owner: Miloslav Mylnikov, RUT - 28.581.607-6, Individual Entrepreneur – Chile
                    </p>
                </section>
            </div>
        </div>
        </div>
    );
}

export default TermsAndConditions;
